import {
  ExportService,
  ExportFileFormat,
  ExportRange,
  ExportContext,
} from "app/layout/export-overlay";
import { Injectable } from "@angular/core";
import { ceil, get } from "lodash-es";
import {
  CHARGE_PARTNER_PROPERTIES,
  CURRENCYFIELDS,
  FORMATTER
} from "./charge-partner.constants";
import { PrincipalScreenService } from "app/modules/components/monitor/principal-screen/principal-screen.service";
import OrderAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/process/order/order.entity";

@Injectable()
export class ChargePartnerExport {
  private currentData: any[] = [];

  constructor(private exportService: ExportService,
    private readonly orederService: PrincipalScreenService,
  ) { }

  setData(data: any[]) {
    this.currentData = data;
  }

  private transform(): any[] {

    return this.currentData.flatMap((item: any) =>
      item.orders.flatMap((order: any) =>
        order.detail.map((detail: any) => ({
          soldToCode: get(order, "soldTo.externalKeys.code", ""),
          soldToName: get(order, "soldTo.name", ""),
          shipToCode: get(item, "shipTo.externalKeys.code", ""),
          shipToName: get(item, "shipTo.name", ""),
          serial: get(order, "serial", ""),
          className: get(order, "class.name", ""),
          materialCode: get(detail, "material.code", ""),
          materialName: get(detail, "material.name", ""),
          soldQuantity: get(detail, "soldQuantity", ""),
          soldUnit: get(detail, "soldUnitOfMeasure.name", ""),
          baseQuantity: get(detail, "baseQuantity", ""),
          baseUnit: get(detail, "baseUnitOfMeasure.name", ""),
          parallelQuantity: get(detail, "pararellQuantity", ""),
          parallelUnit: get(detail, "pararellUnitOfMeasure.name", ""),
          finalPrice: get(detail, "subTotal", ""),
          discounts: get(detail, "totalDiscounts", ""),
          surcharges: get(detail, "totalSurcharges", ""),
          subtotal: get(detail, "subTotalBeforeTaxes", ""),
          taxes: get(detail, "totalTaxes", ""),
          total: get(detail, "total", "")
        }))
      )
    );
  }

  export(format: ExportFileFormat, range: ExportRange,
    totalItems: number,
    exportId: string, exportTitle: string, pageSize: number, 
    pageIndex: number, tripId: number, document_type: string[], searchDocument: string) {
    this.exportService
      .task({
        id: exportId,
        title: exportTitle,
        format,
        iterations: 1,
        start: (ctx: ExportContext) => {
          ctx.processor.localizeItemProperties(
            exportTitle,
            CHARGE_PARTNER_PROPERTIES
          );
        },
        next: async (ctx: ExportContext) => {
          const response : any = await this.orederService
            .getOrdersGroupedByCustomers(
              {
                currentPage: range === ExportRange.AllPages ? 1 : pageIndex,
                limitPerPage: range === ExportRange.AllPages ? totalItems : pageSize,
                search: searchDocument,
                sort: "shipTo.name" as keyof OrderAttributes,
                sortDirection: "ASC",
              },
              tripId,
              document_type
            )
            .toPromise();

            const formattedData = response.data[0].data.flatMap((item: any) =>
                    (item.orders ?? []).flatMap((order: any) =>
                      (order.detail ?? []).map((detail: any) => {
                        const newItem = {
                          ...item,
                          orders: [
                            {
                              ...order,
                              detail: [detail],
                            },
                          ],
                        };
            
                        CURRENCYFIELDS.forEach((field) => {
                          const value = Number(detail[field]);
                          if (!isNaN(value)) {
                            detail[field] = FORMATTER.format(value);
                          }
                        });
            
                        return newItem;
                      })
                    )
                  );
            

            this.currentData = formattedData;
            const rows = this.transform();
            ctx.processor.addToSection(exportTitle, rows);
            ctx.next();
        },
      })
      .start();
  }

  canStartTask(exportId: string): boolean {
    if (this.exportService.taskIsActive(exportId)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}